import { LogoPropsType } from './logoTypes';

export default function ElasticLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 302.3 103.6" className={className}>
      <g>
        <g>
          <path
            d="M104,54.3c0-8.6-5.4-16.4-13.5-19.3c0.4-1.8,0.5-3.7,0.5-5.6C91,13.2,77.8,0,61.6,0
				c-9.5,0-18.3,4.5-23.8,12.2c-2.7-2.1-6.1-3.3-9.5-3.3c-8.6,0-15.6,7-15.6,15.6c0,1.9,0.4,3.7,1,5.5C5.5,32.9,0,40.7,0,49.3
				C0,58,5.4,65.8,13.6,68.7c-0.4,1.8-0.5,3.7-0.5,5.6c0,16.2,13.1,29.3,29.3,29.3c9.4,0,18.3-4.5,23.8-12.2
				c2.7,2.2,6.1,3.3,9.5,3.3c8.6,0,15.6-7,15.6-15.6c0-1.9-0.4-3.7-1-5.5C98.5,70.7,104,63,104,54.3"
            fill={monochrome ? 'currentColor' : '#FFFFFF'}
          />
          <path
            d="M40.9,44.6L63.7,55l23-20.1c0.4-1.7,0.5-3.3,0.5-5.1c0-14.2-11.5-25.7-25.7-25.7c-8.5,0-16.4,4.2-21.1,11.2
				l-3.8,19.8L40.9,44.6z"
            fill={monochrome ? 'currentColor' : '#FED10A'}
          />
          <path
            d="M17.3,68.7c-0.4,1.7-0.5,3.4-0.5,5.1c0,14.2,11.6,25.7,25.8,25.7c8.5,0,16.5-4.2,21.3-11.3l3.8-19.7
				l-5.1-9.7L39.7,48.5L17.3,68.7z"
            fill={monochrome ? 'currentColor' : '#24BBB1'}
          />
          <path
            d="M17.2,29.3L32.8,33l3.4-17.7c-2.1-1.6-4.7-2.5-7.5-2.5c-6.8,0-12.3,5.5-12.3,12.3
				C16.4,26.6,16.7,28,17.2,29.3"
            fill={monochrome ? 'currentColor' : '#EF5098'}
          />
          <path
            d="M15.8,33.1C8.9,35.3,4,42,4,49.4c0,7.2,4.4,13.5,11.1,16.1L37,45.7l-4-8.6L15.8,33.1z"
            fill={monochrome ? 'currentColor' : '#17A8E0'}
          />
          <path
            d="M67.8,88.3c2.2,1.6,4.7,2.5,7.4,2.5c6.8,0,12.3-5.5,12.3-12.3c0-1.5-0.3-2.9-0.7-4.3l-15.6-3.6L67.8,88.3z"
            fill={monochrome ? 'currentColor' : '#93C83E'}
          />
          <path
            d="M71,66.6l17.1,4c7-2.4,11.8-8.9,11.8-16.4c0-7.1-4.4-13.5-11.1-16.1L66.5,57.8L71,66.6z"
            fill={monochrome ? 'currentColor' : '#0779A1'}
          />
          <path
            d="M145.4,72.8l2.1-0.2l0.1,4.2c-5.5,0.7-10.1,1.1-14,1.1c-5.1,0-8.8-1.5-10.9-4.5c-2.2-3-3.2-7.6-3.2-13.9
				c0-12.6,5-18.9,15-18.9c4.8,0,8.4,1.4,10.8,4c2.4,2.7,3.6,6.9,3.6,12.7l-0.3,4.1h-23.7c0,4,0.7,6.9,2.2,8.8
				c1.5,1.9,3.9,2.9,7.5,2.9C138.2,73.2,141.8,73.1,145.4,72.8L145.4,72.8z M143.5,57.2c0-4.4-0.7-7.5-2.1-9.3
				c-1.4-1.8-3.7-2.7-6.9-2.7s-5.6,1-7.2,2.9s-2.4,5-2.4,9.2L143.5,57.2z M156.3,77.7V30.5h5.4v47.2L156.3,77.7z M195.6,52.2v18.1
				c0,1.8,4.4,1.7,4.4,1.7l-0.3,4.7c-3.8,0-6.9,0.3-8.8-1.5c-4.1,1.8-8.4,2.7-12.9,2.7c-3.3,0-5.8-0.9-7.5-2.8
				c-1.7-1.8-2.6-4.5-2.6-8c0-3.5,0.9-6.1,2.6-7.7c1.8-1.6,4.5-2.7,8.3-3l11.3-1.1v-3.1c0-2.4-0.5-4.2-1.6-5.2
				c-1.1-1.1-2.5-1.6-4.3-1.6h-14.1v-4.7H184c4,0,7,0.9,8.8,2.8C194.7,45.3,195.6,48.3,195.6,52.2L195.6,52.2z M173.5,66.8
				c0,4.4,1.8,6.6,5.5,6.6c3.3,0,6.5-0.5,9.6-1.6l1.6-0.6V59.4l-10.6,1c-2.2,0.2-3.7,0.8-4.7,1.8C174,63.3,173.5,64.8,173.5,66.8
				L173.5,66.8z M216.6,45.5c-5.2,0-7.8,1.8-7.8,5.5c0,1.7,0.6,2.9,1.8,3.6s3.9,1.4,8.2,2.2c4.3,0.7,7.3,1.8,9,3.1
				c1.8,1.3,2.6,3.8,2.6,7.5c0,3.7-1.2,6.4-3.6,8.1c-2.4,1.7-5.8,2.6-10.4,2.6c-2.9,0-12.8-1.1-12.8-1.1l0.3-4.7l12.6,1
				c2.8,0,4.9-0.4,6.3-1.3c1.5-0.9,2.2-2.4,2.2-4.4c0-2.1-0.6-3.5-1.8-4.2c-1.2-0.7-4-1.5-8.2-2.1c-4.2-0.7-7.2-1.6-9-2.9
				c-1.8-1.3-2.6-3.7-2.6-7.2c0-3.5,1.2-6.1,3.7-7.7c2.5-1.7,5.5-2.5,9.2-2.5c2.9,0,13,0.7,13,0.7v4.7L216.6,45.5L216.6,45.5z
				M256.3,46.1h-11.4v17.1c0,4.1,0.3,6.8,0.9,8.1c0.6,1.3,2,1.9,4.3,1.9l6.4-0.4l0.4,4.4c-3.2,0.5-5.6,0.8-7.3,0.8
				c-3.7,0-6.3-0.9-7.7-2.7c-1.5-1.8-2.2-5.3-2.2-10.4V46.1h-5.1v-4.7h5.1v-11h5.3v10.9h11.4L256.3,46.1z M263.8,36.8v-6.2h5.4v6.2
				L263.8,36.8L263.8,36.8z M263.8,77.7V41.4h5.4v36.3H263.8z M292.5,40.7c1.6,0,4.3,0.3,8,0.9l1.7,0.2l-0.2,4.4l-8.4-0.7
				c-4,0-6.8,1-8.3,2.9c-1.5,1.9-2.2,5.5-2.2,10.8s0.7,8.9,2,10.9c1.4,2.1,4.2,3.1,8.5,3.1l8.4-0.7l0.2,4.4l-10,1
				c-5.6,0-9.5-1.5-11.6-4.3c-2.1-2.9-3.2-7.7-3.2-14.5s1.1-11.6,3.4-14.3C283.3,42.1,287.1,40.7,292.5,40.7L292.5,40.7z"
            fill={monochrome ? 'currentColor' : '#000000'}
          />
        </g>
      </g>
    </svg>
  );
}
